import { memo } from "react";

const AppPartnersIcon = ({ color = "#3069B2" }) => {
	return (
		<svg width="18" height="17" viewBox="0 0 18 17" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M13.4997 5.14C14.9197 5.14 16.0697 3.99 16.0697 2.57C16.0697 1.15 14.9197 0 13.4997 0C12.0797 0 10.9297 1.15 10.9297 2.57C10.9297 3.99 12.0797 5.14 13.4997 5.14ZM13.4997 1.29C14.2097 1.29 14.7897 1.87 14.7897 2.58C14.7897 3.29 14.2097 3.87 13.4997 3.87C12.7897 3.87 12.2097 3.29 12.2097 2.58C12.2097 1.87 12.7897 1.29 13.4997 1.29Z"
				fill={color}
			/>
			<path
				d="M4.49969 5.14C5.91969 5.14 7.06969 3.99 7.06969 2.57C7.06969 1.15 5.91969 0 4.49969 0C3.07969 0 1.92969 1.15 1.92969 2.57C1.92969 3.99 3.07969 5.14 4.49969 5.14ZM4.49969 1.29C5.20969 1.29 5.78969 1.87 5.78969 2.58C5.78969 3.29 5.20969 3.87 4.49969 3.87C3.78969 3.87 3.20969 3.29 3.20969 2.58C3.20969 1.87 3.78969 1.29 4.49969 1.29Z"
				fill={color}
			/>
			<path
				d="M8.99969 8.99999C10.4197 8.99999 11.5697 7.84999 11.5697 6.42999C11.5697 5.00999 10.4197 3.85999 8.99969 3.85999C7.57969 3.85999 6.42969 5.00999 6.42969 6.42999C6.42969 7.84999 7.57969 8.99999 8.99969 8.99999ZM8.99969 5.13999C9.70969 5.13999 10.2897 5.71999 10.2897 6.42999C10.2897 7.13999 9.70969 7.71999 8.99969 7.71999C8.28969 7.71999 7.70969 7.13999 7.70969 6.42999C7.70969 5.71999 8.28969 5.13999 8.99969 5.13999Z"
				fill={color}
			/>
			<path
				d="M14.7894 5.79004H13.4994C13.1394 5.79004 12.8594 6.08004 12.8594 6.43004C12.8594 6.78004 13.1494 7.07004 13.4994 7.07004H14.7894C15.8594 7.07004 16.7194 7.93004 16.7194 9.00004V11.57H15.4294C15.0694 11.57 14.7894 11.86 14.7894 12.21C14.7894 12.56 15.0794 12.85 15.4294 12.85H17.3594C17.7194 12.85 17.9994 12.56 17.9994 12.21V9.00004C17.9994 7.22004 16.5594 5.79004 14.7894 5.79004Z"
				fill={color}
			/>
			<path
				d="M3.21 7.07004H4.5C4.86 7.07004 5.14 6.78004 5.14 6.43004C5.14 6.08004 4.85 5.79004 4.5 5.79004H3.21C1.43 5.79004 0 7.23004 0 9.00004V12.21C0 12.57 0.29 12.85 0.64 12.85H2.57C2.93 12.85 3.21 12.56 3.21 12.21C3.21 11.86 2.92 11.57 2.57 11.57H1.28V9.00004C1.28 7.93004 2.14 7.07004 3.21 7.07004Z"
				fill={color}
			/>
			<path
				d="M10.2898 9.64001H7.71977C5.93977 9.64001 4.50977 11.08 4.50977 12.85V16.06C4.50977 16.42 4.79977 16.7 5.14977 16.7H12.8598C13.2198 16.7 13.4998 16.41 13.4998 16.06V12.85C13.4998 11.07 12.0598 9.64001 10.2898 9.64001ZM12.2098 15.43H5.77977V12.86C5.77977 11.79 6.63977 10.93 7.70977 10.93H10.2798C11.3498 10.93 12.2098 11.79 12.2098 12.86V15.43Z"
				fill={color}
			/>
		</svg>
	);
};

export default memo(AppPartnersIcon);
